import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Date } from 'apps/components/date';
import { media } from 'legacyComponents/styled/styleUtils';

import { RowStyle, RepoColumn, RepoColumnText } from 'apps/repository/styles';

import { withNamespaces, Trans } from 'react-i18next';

@withNamespaces()
@observer
export class LastModified extends React.Component {
  render() {
    const { fileInfo = {}, isTitle, title } = this.props;
    const { reference } = fileInfo;
    let value;
    if (isTitle) {
      value = title;
    } else if (reference && reference.lastUpdated) {
      value = <Date value={reference && reference.lastUpdated} />;
    } else {
      value = <Trans>n/A</Trans>;
    }
    return (
      <Column
        hidden={!!reference && reference.renaming}
        slim={isTitle}
        isFlex
        isFlexEnd
      >
        <Text isTitle={isTitle}>{value}</Text>
      </Column>
    );
  }
}

const Column = styled(RepoColumn)`
  float: right;
  width: 230px;
  display: ${props =>
    props.hidden ? 'none' : props.isFlex ? 'flex' : 'block'};
  ${RowStyle}:hover & {
    display: none;
  }
  ${media.l`
    width: 230px;
  `}
  ${media.m`
    width: 160px;
  `}
  ${media.xs`
    display: none;
  `}
`;

const Text = styled(RepoColumnText)`
  text-align: right;
  display: block;
  font-size: ${props => (props.isTitle ? '0.75em' : '0.915em')};
  cursor: default;
  &:hover {
    text-decoration: none;
    color: ${props => props.theme.color.wfGrey900};
  }
`;

LastModified.propTypes = {
  fileInfo: PropTypes.object,
  isTitle: PropTypes.bool,
  title: PropTypes.string,
};
